<template>
  <div>
    <div v-if="canEdit && isDirty" class="actions">
      <button class="primary small" :disabled="saving" @click="$emit('save')">
        {{ saving ? 'Saving…' : 'Save changes' }}
      </button>
      <button class="ghost small" type="button" :disabled="saving" @click="$emit('reset')">
        Cancel
      </button>
    </div>

    <p v-if="entity && !isOurCoin" class="ro-hint">
      Read-only: this is not your coin
    </p>
  </div>
</template>

<script setup>
defineProps({
  entity: { type: Object, default: null },
  canEdit: { type: Boolean, default: false },
  isDirty: { type: Boolean, default: false },
  saving: { type: Boolean, default: false },
  isOurCoin: { type: Boolean, default: false },
})

defineEmits(['save', 'reset'])
</script>

<style scoped>
.actions{ margin-top:4px; display:flex; gap:8px; }

.primary.small, .ghost.small{
  padding:4px 10px;
  border-radius:6px;
  font-size:12px;
  cursor:pointer;
  border:1px solid #333;
}
.primary.small{ background:#2563eb; border-color:#2563eb; color:#fff; }
.primary.small:disabled{ opacity:0.5; cursor:default; }
.ghost.small{ background:transparent; color:#aaa; }

.ro-hint{
  margin:2px 0 0;
  font-size:13px;
  color:#4b5563;
  font-style:italic;
  line-height:1.35;
}
</style>
